// Customizer const
export const TOGGLE_COLLAPSED_NAV = "toggle_collapse_menu";
export const DRAWER_TYPE = "drawer_type";
export const FIXED_DRAWER = "fixed_drawer";
export const COLLAPSED_DRAWER = "collapsible";
export const MINI_DRAWER = "mini_drawer";
export const THEME_COLOR = "theme_color";
export const DARK_THEME = "dark_theme";
export const WINDOW_WIDTH = "window-width";
export const SWITCH_LANGUAGE = "switch-language";
export const CHANGE_DIRECTION = "change-direction";

export const CHANGE_NAVIGATION_STYLE = "change-navigation-style";
export const HORIZONTAL_NAVIGATION = "horizontal_navigation";
export const VERTICAL_NAVIGATION = "vertical_navigation";

export const HORIZONTAL_MENU_POSITION = "horizontal_menu_position";
export const ABOVE_THE_HEADER = "above_the_header";
export const INSIDE_THE_HEADER = "inside_the_header";
export const BELOW_THE_HEADER = "below_the_header";

// Auth const
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const REGISTER_USER = "REGISTER_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";

// Listinos
export const FETCH_LISTINOS = "FETCH_LISTINOS";
export const FETCH_LISTINO = "FETCH_LISTINO";
export const IMPORT_LISTINO = "IMPORT_LISTINO";
export const DELETE_LISTINO = "DELETE_LISTINO";
export const EXPORT_LISTINO = "EXPORT_LISTINO";
export const SET_SELECTED_CONTACT = "SET_SELECTED_CONTACT";
export const CLEAR_EXPORT_FIELDS = "CLEAR_EXPORT_FIELDS";

// Contacts
export const FETCH_CONTACTS = "FETCH_CONTACTS";
export const FETCH_CONTACT = "FETCH_CONTACT";
export const CREATE_CONTACT = "CREATE_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const SEARCH_CONTACTS = "SEARCH_CONTACTS";
export const FETCH_CONTACT_FIELDS = "FETCH_CONTACT_FIELDS";
export const IMPORT_CONTACTS = "IMPORT_CONTACTS";
export const FETCH_LOG_CONTACT = "FETCH_LOG_CONTACT";

// Logs
export const FETCH_LOGS = "FETCH_LOGS";
export const DELETE_LOG = "DELETE_LOG";
export const DELETE_LOGS = "DELETE_LOGS";

// Analytics
export const FETCH_BASIC_ANALYTICS = "FETCH_BASIC_ANALYTICS";
export const FETCH_PRODUCT_FREQUENCIES = "FETCH_PRODUCT_FREQUENCIES";

// Grid
export const GRID_STATE_CHANGE = "GRID_STATE_CHANGE";
export const CLEAR_GRID = "CLEAR_GRID";

// Settings
export const FETCH_SITE_SETTINGS = "FETCH_SITE_SETTINGS";
export const UPDATE_SITE_SETTINGS = "UPDATE_SITE_SETTINGS";

// Users
export const FETCH_USERS = "FETCH_USERS";



// WEBPACK FOOTER //
// ./constants/ActionTypes.js